// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc3621de","453":"258b012d","667":"df274394"}[chunkId] + ".chunk.js";
};